var _filter, _filter2, _animateTransform, _pattern, _rect, _rect2, _g, _rect3, _g2, _script, _link;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChainwiseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 240,
    viewBox: "0 0 400 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "neonGlow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "strongGlow",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "bigBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "bigBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "primaryGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00ff88",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#00d4ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ff0080",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hexGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00ff88",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#00d4ff",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ff0080",
      stopOpacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "textGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00ff88",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    style: {
      stopColor: "#00d4ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#ff0080",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    style: {
      stopColor: "#00d4ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#00ff88",
      stopOpacity: 1
    }
  }), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "gradientTransform",
    type: "translate",
    values: "-50 0; 50 0; -50 0",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "circuitPattern",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#0a0a0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10 L20 10 M10 0 L10 20",
    stroke: "#00ff88",
    strokeWidth: 0.5,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 1,
    fill: "#00ff88",
    opacity: 0.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 120,
    fill: "#0a0a0f",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 120,
    fill: "url(#circuitPattern)",
    rx: 8,
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 60)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120, 0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-20 17.32,-10 17.32,10 0,20 -17.32,10 -17.32,-10",
    fill: "none",
    stroke: "url(#primaryGradient)",
    strokeWidth: 2,
    filter: "url(#strongGlow)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: 0,
    to: 360,
    dur: "20s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0,-12 10.39,-6 10.39,6 0,12 -10.39,6 -10.39,-6",
    fill: "url(#hexGradient)",
    stroke: "#00ff88",
    strokeWidth: 1,
    filter: "url(#neonGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4,
    fill: "#00ff88",
    filter: "url(#strongGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4;6;4",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.7;1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#00d4ff",
    strokeWidth: 1,
    opacity: 0.8,
    filter: "url(#neonGlow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -12,
    x2: 0,
    y2: -20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.39,
    y1: -6,
    x2: 17.32,
    y2: -10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.39,
    y1: 6,
    x2: 17.32,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 12,
    x2: 0,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10.39,
    y1: 6,
    x2: -17.32,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10.39,
    y1: -6,
    x2: -17.32,
    y2: -10
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff0080",
    filter: "url(#neonGlow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -25,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 21.65,
    cy: -12.5,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.3s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 21.65,
    cy: 12.5,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.6s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 25,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.9s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -21.65,
    cy: 12.5,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "1.2s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -21.65,
    cy: -12.5,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "1.5s"
  })))), /*#__PURE__*/React.createElement("g", {
    stroke: "#00ff88",
    strokeWidth: 1,
    opacity: 0.6,
    filter: "url(#neonGlow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -95,
    y1: 0,
    x2: -70,
    y2: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: -95,
    y1: -8,
    x2: -70,
    y2: -5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("line", {
    x1: -95,
    y1: 8,
    x2: -70,
    y2: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Orbitron, monospace",
    fontSize: 22,
    fontWeight: 900,
    fill: "url(#textGradient)",
    filter: "url(#strongGlow)",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "CHAINWISE")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120, 0) scale(-1, 1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-20 17.32,-10 17.32,10 0,20 -17.32,10 -17.32,-10",
    fill: "none",
    stroke: "url(#primaryGradient)",
    strokeWidth: 2,
    filter: "url(#strongGlow)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: 360,
    to: 0,
    dur: "20s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0,-12 10.39,-6 10.39,6 0,12 -10.39,6 -10.39,-6",
    fill: "url(#hexGradient)",
    stroke: "#00ff88",
    strokeWidth: 1,
    filter: "url(#neonGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4,
    fill: "#00ff88",
    filter: "url(#strongGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "4;6;4",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.7;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#00d4ff",
    strokeWidth: 1,
    opacity: 0.8,
    filter: "url(#neonGlow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -12,
    x2: 0,
    y2: -20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.39,
    y1: -6,
    x2: 17.32,
    y2: -10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.39,
    y1: 6,
    x2: 17.32,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 12,
    x2: 0,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10.39,
    y1: 6,
    x2: -17.32,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10.39,
    y1: -6,
    x2: -17.32,
    y2: -10
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff0080",
    filter: "url(#neonGlow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -25,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "1.5s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 21.65,
    cy: -12.5,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "1.2s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 21.65,
    cy: 12.5,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.9s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 25,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.6s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -21.65,
    cy: 12.5,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.3s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -21.65,
    cy: -12.5,
    r: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0s"
  })))), /*#__PURE__*/React.createElement("g", {
    stroke: "#00ff88",
    strokeWidth: 1,
    opacity: 0.6,
    filter: "url(#neonGlow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 0,
    x2: 70,
    y2: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: -8,
    x2: 70,
    y2: -5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.5s"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 8,
    x2: 70,
    y2: 5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0s"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#ff0080",
    strokeWidth: 0.5,
    opacity: 0.4,
    filter: "url(#neonGlow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -95,
    y1: -15,
    x2: 95,
    y2: -15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    x1: -95,
    y1: 15,
    x2: 95,
    y2: 15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "1.5s"
  }))))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2,
    height: 120,
    fill: "#00ff88",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0,0; 400,0; 0,0",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 3,
    fill: "#00ff88",
    filter: "url(#strongGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.8;0.3",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 20,
    r: 3,
    fill: "#ff0080",
    filter: "url(#strongGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.8;0.3",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "1s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 100,
    r: 3,
    fill: "#00d4ff",
    filter: "url(#strongGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.8;0.3",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "2s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 100,
    r: 3,
    fill: "#00ff88",
    filter: "url(#strongGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.8;0.3",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "3s"
  })))), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainwiseLogo);
export default __webpack_public_path__ + "static/media/chainwise-logo.a537d0e4f3e65b1570fc96efe41cb8cf.svg";
export { ForwardRef as ReactComponent };